<!-- eslint-disable vue/multi-word-component-names -->
<!--
//================================================================================
// ID:-
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:Pagination
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/06 | 富士通株式会社         | 新規作成
// 01.01.00 | 2023/10/30 | 富士通Japan株式会社    | 令和5年度改修対応（3次リリース）
// 01.02.00 | 2025/02/03 | 富士通Japan株式会社    | 令和6年度改修対応（2次リリース）
//================================================================================
-->
<template>
	<div
		id="contents__list--page"
		:class="[displayFotterFlg == false ? 'contents__list--page-head' : 'contents__list--page-foot']"
	>
		<div v-if="displaySortFlg && !displayFotterFlg">
			<list-box
				ref="sortOrder"
				:modelValue="sortOrder"
				class="contents__input--select width-sort"
				:name="'並び順'"
				:list-items="disp.sortOrdeItems"
				:blank-flg="false"
				:reduced-display-flg="true"
				:tabindex="tabindex"
				@update:modelValue="sortOrder = $event"
			/>
			<input
				type="button"
				class="contents__btn--normal width-auto btn__sort btn-narabikae-padding"
				value="並び替え"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 1)"
				@click="clickSortByBtn()"
			>
		</div>
		<div
			v-else-if="!displaySortFlg && !displayFotterFlg"
			class="contents__list--page-headertitle"
		>
			<h2 class="contents__h2 contents__list--page-h2">
				{{ headerTitle }}
			</h2>
		</div>
		<div class="margin__auto">
			<ul :class="[displayFotterFlg == false ? 'page__number--head-ul' : 'page__number--foot-ul']">
				<li
					v-if="isBeforePage"
					:class="['pagetProperty', displayFotterFlg == false ? 'page__before-head' : 'page__before-foot', ' width-auto', 'page__before-font']"
					:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 2)"
				>
					<a
						class="pagNation-cursor"
						@click="clickPreviousPage"
					>{{ previewMark }}前へ</a>
				</li>
				<li
					v-for="(item, index) in disp.pageBtnItems"
					:ref="'refs_' + index"
					:key="item.key"
					:class="['pagetProperty', item.key == currentPage ? 'active' : '', ' width-auto', 'page__number-font']"
					:tabindex="Number(tabindex) > 0 && item.key != currentPage ? String(Number(tabindex) + (3+index)):-1"
					@keyup.enter="clickPage(item.key)"
				>
					<a
						class="pagNation-cursor"
						@click="clickPage(item.key)"
					> {{ item.value }}</a>
				</li>
				<li
					v-if="isNextPage"
					class="pagetProperty width-auto page__next-font"
					:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 8)"
				>
					<a
						class="pagNation-cursor"
						@click="clickNextPage"
					> 次へ{{ nextMark }}</a>
				</li>
			</ul>
		</div>
		<div
			v-if="!displayFotterFlg"
			class="margin__left-5"
		>
			<b class="contents__page--total-meisai-cnt">{{ listCount }}</b>
			<label class="meisai-cnt-size">件中{{ displayStartIndex }}～{{ displayEndIndex }}件を表示</label>
		</div>
		<div
			v-if="!displayFotterFlg"
			class="margin__left-10"
		>
			<list-box
				ref="displayCount"
				:modelValue="displayCount"
				class="contents__input--select width-auto"
				:name="'表示件数'"
				:cd-type="'L0015'"
				:cd-kbn="CD_HANDLE_TYPE.CD_HANYO1"
				:blank-flg="false"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 9)"
				@update:modelValue="displayCount = $event"
			/>
			<input
				type="button"
				class="contents__btn--normal width-auto margin__left-5 btn-hyouji-padding"
				value="表示"
				:tabindex="Number(tabindex) <= 0 ? tabindex:String(Number(tabindex) + 10)"
				@click="clickDisplayBtn()"
			>
		</div>
	</div>
</template>

<script>
import ListBox from '@/components/ListBox.vue';
import { co_post } from '@/common/ajaxUtility.js';
import { CD_HANDLE_TYPE, SORT_KIND } from '@/const/const.js';
import { API_LIST_ITEMS } from '@/const/route.js';
import { STORE_VIEW_PAGE, STORE_VIEW_GET_PAGE, STORE_VIEW_VIEW_COUNT, STORE_VIEW_GET_VIEW_COUNT,
			STORE_VIEW_SORT_ORDER, STORE_VIEW_GET_SORT_ORDER } from '@/const/store.js';

export default {
	components: {
		'list-box': ListBox,
	},
	props: {
		listCount: {Number, default: 0},						// 明細件数
		tabindex: {type: String, default: '0'},					// タブインデックス
		clickSortList: {type: Function, default: function() {
				return null
			}
		},														// 並び替えイベント
		clickPageSwitch: {type: Function, default: function() {
				return null
			}
		},														// ページ移動イベント
		displaySortFlg: { type: Boolean, default: false },		// ソート順表示フラグ
		displayFotterFlg: { type: Boolean, default: false },	// フッターフラグ
		headerTitle: {type: String, default: ''},				// 見出し
		bairituVisibilityFlg: { type: Boolean, default: false },// 参考倍率の表示/非表示有無
		okiniiriVisibilityFlg: { type: Boolean, default: false },// お気に入りの登録順の表示/非表示有無
		akijyukoVisibilityFlg: { type: Boolean, default: false },// 空き住戸数の多い順の表示/非表示有無
		sortType: { type: Number, default: SORT_KIND.NORMAL },	// 並び替えの種類
	},
	data: function () {
		return {
			sortOrder: '',				// 並び順
			initSortOrder: '',			// 並び順初期値
			displayCount: '',			// 表示件数
			displayStartIndex: 0,		// 表示開始行数
			displayEndIndex: 0, 		// 表示終了行数
			totalPageCnt: 0,			// 総ページ数
			isBeforePage: false,		// 前ページ表示可否
			isNextPage: false,			// 次ページ表示可否
			previewMark: '<<',			// 前ページ記号
			nextMark: '>>',				// 次ページ記号
			isSortSiborikomi: false,	// 並び替えリスト絞り込み処理中フラグ
			disp: {
				sortOrdeItems: [], 
				pageBtnItems: [],		// ボタンリスト
				displayCount: '',
			},
			CD_HANDLE_TYPE: CD_HANDLE_TYPE
		}
	},
	computed: {
		currentPage: function () {
			return this.$store.getters[STORE_VIEW_GET_PAGE];
		},
		displayCountFooter: function () {
			return this.$store.getters[STORE_VIEW_GET_VIEW_COUNT];
		}
	},
	watch: {
		bairituVisibilityFlg: function() {

			if (this.sortType != SORT_KIND.NORMAL) {
				return;
			}

			// 「参考倍率が低い順」の表示制御
			if (!this.bairituVisibilityFlg) {
				let sortOrderList = [];
				for (let i = 0; i < this.disp.sortOrdeItems.length; i++) {
					if (this.disp.sortOrdeItems[i].idCd != '07') {
						sortOrderList.push(this.disp.sortOrdeItems[i]);
					}
				}

				this.disp.sortOrdeItems = sortOrderList;

				if (this.sortOrder == '07' ) {
					this.sortOrder = this.initSortOrder;
				}
			}
			
		},
		currentPage: function () {
			if (this.currentPage > 0) {
				this.calcPage(this.currentPage);
			}
		},
		displayCountFooter: function () {
			this.calcPage(1);
		},
		listCount: function () {
			// this.calcPage(1);
			this.calcPage(this.currentPage);
		}
	},
	created: async function() {

		let isSelectSortOrder = false;

		// 並び順設定
		if (!this.displayFotterFlg) {

			// 並び替えのコードタイプ設定
			let sortCdType = '';
			if (this.sortType == SORT_KIND.ZUIJI) {
				// 並び替え（随時募集）の場合
				sortCdType = 'L0097';
			} else if (this.sortType == SORT_KIND.KANRI) {
				// 並び替え（随時募集（住宅メンテ））の場合
				sortCdType = 'L0095';
			} else if (this.sortType == SORT_KIND.OKINIIRI) {
				// 並び替えリスト（お気に入り登録）の場合
				sortCdType = 'L0107';
			} else {
				// 並び替え（毎月募集、定期募集）の場合
				sortCdType = 'L0036';
			}

			let params = { cdType: sortCdType, cdHanyo1: '', cdHanyo2: '', cdHanyo3: '' };
			let list = await co_post( API_LIST_ITEMS, params );
			if ( list != null ) {

				let storeSortOrder = this.$store.getters[STORE_VIEW_GET_SORT_ORDER];
				// let isSelectSortOrder = false;
				let sortOrdeItems = new Array();
				for ( let i = 0; i < list.length; i++ ) {
					// リストを追加
					sortOrdeItems.push( {idCd: list[i].idCd, nmCd: list[i].nmCd} );
					if (list[i].cdHanyo1 == '1') {
						this.initSortOrder = list[i].idCd;
						if (this.$store.getters[STORE_VIEW_GET_SORT_ORDER] == '') {
							// ページ情報が初期化されている場合のみ
							this.sortOrder = list[i].idCd;
							// this.$store.commit(STORE_VIEW_SORT_ORDER, this.sortOrder);
						}
					}

					if (storeSortOrder != '') {
						if (list[i].idCd == storeSortOrder) {
							isSelectSortOrder = true;
						}
					}
				}

				let delCodeList = new Array();
				if (!this.okiniiriVisibilityFlg) {
					delCodeList.push('15');
				}
				if (!this.akijyukoVisibilityFlg) {
					delCodeList.push('16');
				}
				// 並び替えリストの表示制御
				if (!this.okiniiriVisibilityFlg || !this.akijyukoVisibilityFlg) {
					let siborikomiSortOrdeItems = new Array();
					for ( let i = 0; i < sortOrdeItems.length; i++ ) {
						siborikomiSortOrdeItems.push(sortOrdeItems[i]);
					}
					delCodeList.forEach((id) => {
						let index = siborikomiSortOrdeItems.findIndex((item) => item.idCd === id);
						if (index !== -1) {
							siborikomiSortOrdeItems.splice(index, 1);
						}
					});
					this.disp.sortOrdeItems = siborikomiSortOrdeItems;
					if ((!this.okiniiriVisibilityFlg && storeSortOrder == '15')
						|| (!this.akijyukoVisibilityFlg && storeSortOrder == '16')) {
						isSelectSortOrder = false;
					}
				} else {
					this.disp.sortOrdeItems= sortOrdeItems;
				}

				// ストアに記録された並び順がリストに存在しない場合、初期値を選択
				if (!isSelectSortOrder) {
					this.sortOrder = this.initSortOrder;
					// this.$store.commit(STORE_VIEW_SORT_ORDER, this.sortOrder);
				}
			}
		}

		// 表示件数
		if (this.$store.getters[STORE_VIEW_GET_VIEW_COUNT] == 0) {
			this.displayCount = '10';
			this.disp.displayCount = '10';
			this.displayCountFooter = this.displayCount;
		} else {
			this.displayCount = this.$store.getters[STORE_VIEW_GET_VIEW_COUNT];
			this.disp.displayCount = this.$store.getters[STORE_VIEW_GET_VIEW_COUNT];
			this.displayCountFooter = this.$store.getters[STORE_VIEW_GET_VIEW_COUNT];
		}

		// 並び順
		// if (this.$store.getters[STORE_VIEW_GET_SORT_ORDER] != '') {
		// 	this.sortOrder = this.$store.getters[STORE_VIEW_GET_SORT_ORDER];
		// }
		if (isSelectSortOrder) {
			if (this.$store.getters[STORE_VIEW_GET_SORT_ORDER] != '') {
				this.sortOrder = this.$store.getters[STORE_VIEW_GET_SORT_ORDER];
			}
		}
		

		// 表示ページ
		if (this.$store.getters[STORE_VIEW_GET_PAGE] == 0) {
			this.$store.commit(STORE_VIEW_PAGE, 1);
			this.$store.commit(STORE_VIEW_VIEW_COUNT, this.displayCount);
			this.calcPage(1); 
		} else {
			this.calcPage(this.$store.getters[STORE_VIEW_GET_PAGE]); 
		}

	},
	methods: {
		// 並び替えボタン押下
		clickSortByBtn: function () {

			// 表示件数
			let displayCount = Number(this.disp.displayCount);

			// 表示開始行数
			this.displayStartIndex = 1;

			// 表示終了行数
			this.displayEndIndex = displayCount > this.listCount ? this.listCount : displayCount;

			// 表示ページ
			this.$store.commit(STORE_VIEW_PAGE, 1);

			// 並び替え保持
			this.$store.commit(STORE_VIEW_SORT_ORDER, this.sortOrder);

			// 親コンポーネントにリストの並び替えを通知
			this.clickSortList(this.sortOrder, this.displayStartIndex-1, this.displayEndIndex);
		},
		// 前ページ移動ボタン押下
		clickPreviousPage: function () {
			this.$store.commit(STORE_VIEW_PAGE, this.currentPage - 1);
		},
		// 次ページ移動ボタン押下
		clickNextPage: function () {
			this.$store.commit(STORE_VIEW_PAGE, this.currentPage + 1);
		},
		// ページ選択ボタン押下
		clickPage: function ( page ) {
			this.$store.commit(STORE_VIEW_PAGE, page);
		},
		// 表示件数変更ボタン
		clickDisplayBtn: function () {
			this.$store.commit(STORE_VIEW_PAGE, 1);
			this.$store.commit(STORE_VIEW_VIEW_COUNT, this.displayCount);
			this.disp.displayCount = this.displayCount;
		},
		// ページ計算
		calcPage: function ( page ) {

			// 表示件数
			let displayCount = Number(this.displayCountFooter);

			// 総ページ数
			let totalPageCnt = Math.ceil(Number(this.listCount) / displayCount);
			this.totalPageCnt = totalPageCnt;

			// 表示ページ
			let viewPage = page;
			if (totalPageCnt > 0 && page > totalPageCnt) {
				viewPage = totalPageCnt;
			}

			// 表示開始行数
			this.displayStartIndex = ((viewPage-1) * displayCount) + 1;

			// 表示終了行数
			let displayEndIndex = ((viewPage-1) * displayCount) + displayCount;

			this.displayEndIndex = displayEndIndex > this.listCount ? this.listCount : displayEndIndex;

			// 前ページ移動ボタン制御
			if (viewPage != 1) {
				this.isBeforePage = true;
			} else {
				this.isBeforePage = false;
			}

			// 次ページ移動ボタン制御
			if (viewPage != this.totalPageCnt) {
				this.isNextPage = true;
			} else {
				this.isNextPage = false;
			}

			// 生成ページ数
			let createPageCnt = this.totalPageCnt < 5 ? this.totalPageCnt : 5;

			// ページボタン設定
			let pageBtnItemList = [];

			// 開始行番号設定
			let startPage =  0;
			if (2 < viewPage) {
				if (viewPage - 3 < 0) {
					startPage = 0;
				} else {
					if (this.totalPageCnt - (viewPage - 2) < 5) {
						startPage = this.totalPageCnt - createPageCnt;
					} else {
						startPage = viewPage - 3;
					}
				}
			} else {
				startPage = 0;
			}

			// 終了行番号設定
			let endPage = ((startPage + createPageCnt) < this.totalPageCnt) ? startPage + createPageCnt : this.totalPageCnt;

			// ページボタン設定
			for (let i = startPage; i < endPage; i++) {
				pageBtnItemList.push({
									key : i + 1, value : i + 1
									});
			}
			this.disp.pageBtnItems = pageBtnItemList;

			// 親コンポーネントにリストのページ切替を通知
			this.clickPageSwitch(this.displayStartIndex-1, this.displayEndIndex);
		},
		// フォーカス設定
		focus: function() {
			if (this.displaySortFlg) {
				this.$refs.sortOrder.focus();
			} else {
				this.$refs.displayCount.focus();
			}
			
		}
	},
}
</script>

<style>

.page__number--foot-ul {
	display: block !important;
	margin-right: auto;
	margin-left: auto;
	width: max-content !important;
}

/* 端末がPCの場合 */
@media screen and (min-width: 768px) {
	.btn__sort {
		margin-left: 5px;
		margin-right: 15px;
	}

	.page__number--head-ul {
		display: block !important;
		margin-right: auto;
		margin-left: auto;
	}

	.meisai-cnt-size {
		font-size: 16px;
	}

	.page__before-font {
		font-size: 16px;
		color: #0000EE;
	}

	.page__number-font {
		font-size: 16px;
		color: #0000EE;
	}

	.page__next-font {
		font-size: 16px;
		color: #0000EE;
	}
	.btn-narabikae-padding {
		padding: .5em 0.6em !important;
	}
	.btn-hyouji-padding {
		padding: .5em 1.1em !important;
	}
	.pagNation-cursor {
		cursor: pointer;
	}
}

/* 端末がスマホの場合 */
@media screen and (max-width: 767px) {
	.btn__sort {
		margin-left: 5px;
		/* margin-right: 15px; */
	}

	.page__number--head-ul {
		display: block !important;
		margin-right: auto;
		margin-left: auto;
		width: max-content !important;
	}

	.meisai-cnt-size {
		font-size: 18px;
	}

	.page__before-font {
		font-size: 15px;
		color: #0000EE;
	}

	.page__number-font {
		font-size: 15px;
		color: #0000EE;
	}

	.page__next-font {
		font-size: 15px;
		color: #0000EE;
	}
}

</style>